<template>
    <div class="card card-body text-center">
        <div class="form-group flex justify-center text-center" :class="{'mt-3' : !forUpgrade}">
            <img class="task-img" src="/images/animat-checkmark-color.gif" :class="{'check-image' : forUpgrade}">
        </div>
        <h4 class="text-lg font-medium" v-if="forUpgrade">Sign Your New Debit Order To Complete The Upgrade</h4>
        <h4 class="text-lg font-medium" v-else>Sign Your Debit Order</h4>
        <p style="max-width: 500px; margin:auto;">
            {{ textDescription }}
        </p>
        <div class="mt-1" v-show="!sendAuthRequestEmail">
            <a :href="signNowLink" class="btn btn-outline-primary mt-2">Sign now</a>
            <button @click.prevent="sendAuthRequestEmail = true" class="btn btn-outline-primary mt-2">
                Email Link
            </button>
        </div>
        <div class=" form-inline mt-2" v-if="sendAuthRequestEmail">
            <div class="text-center m-auto flex flex-col">
                <div class="mr-1 gap-2">
                    <input class="form-control" type="text"
                           v-model="form.email"
                           placeholder="Enter email address"
                           :class="{'is-invalid': form.errors.has('email')}">
                    <span class="invalid-feedback w-auto"
                          v-show="form.errors.has('email')">
                        {{ form.errors.get("email") }}
                    </span>

                    <button class="btn btn-success waves-effect waves-light mr-1 mt-2 w-1/2 align-self-baseline"
                            @click.prevent="sendDebitOrderAuthRequest"
                            :disabled="form.busy">
                        {{ form.busy ? "Sending..." : "Send" }}
                    </button>
                    <button class="btn btn-default waves-effect waves-light mr-1 mt-2 align-self-baseline"
                            @click.prevent="sendAuthRequestEmail = false"
                            :disabled="form.busy">
                        Cancel
                    </button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    props: ["token", "forUpgrade"],

    data () {
        return {
            sendAuthRequestEmail: false,
            form: new AppForm({})
        };
    },

    methods: {

        sendDebitOrderAuthRequest () {
            App.post("/onboarding/debitorder/send", this.form)
            .then(() => {
                this.sendAuthRequestEmail = false;
                swal(
                    "Email sent!",
                    "Debit order authorization request sent to " + this.form.email + "!",
                    "success"
                );
            });
        }
    },

    computed: {
        signNowLink () {
            return "/onboarding/debitorder/" + this.token;
        },

        textDescription () {
            if (this.forUpgrade) {
                return "Sign the new debit order now to upgrade your account " +
                    "or email the link to an authorized account holder if you're " +
                    "not authorized to sign.";
            } else {
                return "Sign the debit order online to activate your account " +
                    "or email the link to an authorized account holder if you're " +
                    "not authorized to sign.";
            }
        }
    }

};
</script>

<style scoped>
.check-image {
    max-width: 50px;
}
</style>
